<template>
  <a-col :span="span" class="dashboard-item" v-bind:class="{ dark: deleted, handle:!deleted }">
    <template v-if="edit">
      <a-icon v-if="!deleted" type="delete" style="position:absolute;right:12px;top:2px;z-index:1"
              @click="whenDelete"></a-icon>
      <a-icon v-if="deleted" type="undo" style="position:absolute;right:12px;top:2px;z-index:1"
              @click="whenUnDelete"></a-icon>
    </template>
    <slot/>
  </a-col>
</template>

<script>
export default {
  name: 'DashboardItem',
  props: {
    span: {
      type: Number
    },
    dashboardKey: {
      type: String
    },
    deleted: {
      type: Boolean,
      default: false
    },
    onDelete: {
      type: Function
    },
    unDelete: {
      type: Function
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getDashboardKey () {
      return this.dashboardKey
    },
    whenDelete () {
      this.deleted = true
      this.onDelete(this.getDashboardKey())
    },
    whenUnDelete () {
      this.deleted = false
      this.unDelete(this.getDashboardKey())
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.dashboard-item {
  margin: 10px 0 10px 0;
}

.dark /deep/ .ant-card{
    background-color: #dbdbdb;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/DashboardItem.vue